import { StreamActions } from "@hotwired/turbo"
import { showToast } from "../lib/bs_toast"

// Eigene Turbo-Stream-Actions (Anleitung: https://marcoroth.dev/posts/guide-to-custom-turbo-stream-actions).
// Serverseitig erzeugt über turbo_stream.<action> (TurboStreamActionsHelper) bzw. Turbo::StreamsChannel.

// notify: Toast mit dem Text aus "message", Farbe aus "type" (Rails-flash-Key oder success/info/warning/danger).
StreamActions.notify = function () {
  showToast(this.getAttribute("message"), { type: this.getAttribute("type") || undefined })
}

// append_unless_present: wie append, lässt aber ein schon vorhandenes Element mit derselben id stehen (append würde es
// ersetzen). Z.B. das aufgeklappte Gerät mit seiner Geräteinfo, wenn smartphone_ready nach einem Reconnect des Cables
// den laufenden Run wiederherstellt.
StreamActions.append_unless_present = function () {
  const element = this.templateContent.firstElementChild
  if (element?.id && document.getElementById(element.id)) return

  this.targetElements.forEach((target) => target.append(this.templateContent))
}
